module.exports = __webpack_public_path__ + "img/jinggair.38411533.png";